import React from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import {
  StyledCardListOfLinks,
  ToolsListContainer,
  ToolsMenuContainer
} from "./style";
import {
  ActionTypes,
  TOOL_OPTIONS_GROUPS
} from "../../../../../constants/toolsOptions";
import { Menu } from "../../../../../projectSpecificComponents/menu";
import {
  changePanel,
  getTargetPanelData
} from "../../../../../assets/changePanel";
import { checkAccessesForManagerPanel } from "../../../../../assets/checkAccess";
import { teamManagementHandle } from "../../../../../assets/teamManagementMenuHandle";
import TeamManagementMenuModal from "../../../../../projectSpecificComponents/teamManagementMenuModal";
import { renderPremiumText } from "../../../../../assets/renderPremiumIconWithText";
import { checkPremiumFeature } from "../../../../../assets/checkPremium";
import { IMPORT_ACCOUNT_TITLE } from "../../../../../constants/premiumActions";
import makeSafeToUseInDangerousInnerHtml from "../../../../../lib/makeSafeToUseInDangerousInnerHtml";

const Index = props => {
  const { init, show, handleShow, history } = props;
  const onClickHandle = tool => {
    let checkAction = true;
    if (tool.premium) {
      const showPremiumMessage = checkPremiumFeature(tool.premium, true);
      if (!showPremiumMessage) {
        if (!tool.action && tool.link) {
          checkAction = false;
          history.push(tool.link);
        }
      }
    }
    if (checkAction) {
      switch (tool.action) {
        case ActionTypes.SWITCH_PANEL:
          changePanel();
          break;
        case ActionTypes.TEAM_MANAGEMENT:
          teamManagementHandle();
          break;
      }
    }
  };

  const targetPanel = getTargetPanelData();
  return (
    <React.Fragment>
      <TeamManagementMenuModal />
      <Menu showMenu={show} close={() => handleShow(false)} isSmall={true}>
        <ToolsMenuContainer>
          <ToolsListContainer>
            {TOOL_OPTIONS_GROUPS(targetPanel, history, init.project).map(
              (group, key) => {
                return (
                  <StyledCardListOfLinks key={key}>
                    <div className="title">{group.title}</div>
                    {group.list.map((tool, i) => {
                      if (
                        !tool.hide &&
                        ((tool.accesses &&
                          checkAccessesForManagerPanel(tool.accesses)) ||
                          !tool.accesses)
                      ) {
                        if (tool.action || tool.premium) {
                          return (
                            <li
                              className="tool-item"
                              key={i}
                              onClick={() => onClickHandle(tool)}
                            >
                              <Link
                                to={(!tool.premium && tool.link) || "#"}
                                disabled
                              >
                                {/* "#" is fake link to prevent warning*/}
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: makeSafeToUseInDangerousInnerHtml(
                                      renderPremiumText(
                                        tool.value,
                                        showMessage =>
                                          checkPremiumFeature(
                                            tool.premium,
                                            showMessage
                                          )
                                      )
                                    )
                                  }}
                                />
                              </Link>
                            </li>
                          );
                        } else {
                          return (
                            <li key={i} className="tool-item">
                              <Link to={tool.link}>
                                <span>{tool.value}</span>
                              </Link>
                            </li>
                          );
                        }
                      }
                    })}
                  </StyledCardListOfLinks>
                );
              }
            )}
          </ToolsListContainer>
        </ToolsMenuContainer>
      </Menu>
    </React.Fragment>
  );
};
const mapStateToProps = store => {
  return {
    init: store.Init.data,
    loading: store.Project.loading
  };
};

export default connect(mapStateToProps)(withRouter(Index));
